import { assetSecuritiesReportStateSchema } from './types'
import _get from 'lodash/get'
import { z } from 'zod/mini'

import { getMessage } from '../../../../common/utils/MessageUtils'

export const ValidateCompanyConfig = z.object({
  tempEmpCalcBase: z.string().check(z.minLength(1, getMessage('E010014', '臨時従業員（計算対象）', '選択'))),
  tempEmpCalcMethod: z.string().check(z.minLength(1, getMessage('E010014', '臨時従業員（計算方法）', '選択'))),
  genderStatsAll: z.string(),
  genderStatsRegular: z.string(),
  genderStatsNonRegular: z.string()
})

/** @param {z.core.$ZodError} errors */
const convertZodErrorToClientErrors = (errors) => {
  const clientErrors = errors.issues.reduce((acc, e) => {
    if (!acc[e.path]) acc[e.path] = []
    acc[e.path].push(e.message)
    return acc
  }, {})

  return {
    isError: true,
    clientErrors: clientErrors
  }
}

/**
 * @function runValidation バリデーション
 * @param {any} store
 */
export const runValidation = async (store) => {
  const state = assetSecuritiesReportStateSchema(store.getState())

  try {
    const selectedYear = state.selectedFiscalYear
    const selectedCompanyConfig = _get(state.pageState, [selectedYear, 'companyConfig'])

    await ValidateCompanyConfig.parseAsync(selectedCompanyConfig)

    return {
      isError: false
    }
  } catch (error) {
    return convertZodErrorToClientErrors(error)
  }
}
